"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FusionStatus = void 0;
var FusionStatus;
(function (FusionStatus) {
    FusionStatus["PENDING"] = "PENDING";
    FusionStatus["SUCCESS"] = "SUCCESS";
    FusionStatus["FAILED"] = "FAILED";
    FusionStatus["TO_BE_MINTED"] = "TO_BE_MINTED";
})(FusionStatus || (exports.FusionStatus = FusionStatus = {}));
